
import { ILegalStatus, ILegalType } from "@wot/typings";
import xhr from "../utils/fetch";

interface ILegalReqBody {
  _id?: string,
  mdText: string,
  type: ILegalType
}
interface ILegalUpdateReqBody {
  _id: string,
  status: ILegalStatus
}

const addDocument = async (document: ILegalReqBody) => {
  return await xhr({
    url: `/a/legal`,
    method: "POST",
    body: document
  }).then((res) => res.data)
    .catch(err => { throw err })
}

const updateDocument = async (document: ILegalUpdateReqBody) => {
  return await xhr({
    url: `/a/legal`,
    method: "PUT",
    body: document
  }).then((res) => res.data)
    .catch(err => { throw err })
}

const getDocuments = async (type: ILegalType) => {
  return await xhr({
    url: `/legal?type=${type}`,
    method: "GET",
  }).then((res) => res.data)
    .catch(err => { throw err })
}

const legalApi = {
  addDocument,
  updateDocument,
  getDocuments
}

export default legalApi